var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavelines1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 876,
    viewBox: "0 0 1440 876",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.111111,
    d: "M1476.51 343.385C1372.51 379.721 1257.57 421.043 1031.75 459.356C805.923 497.669 727.823 513.533 598.24 566.896C468.656 620.259 427.288 627.534 128.562 640.36C-170.71 653.21 -569.308 815.062 -569.308 815.062",
    stroke: "url(#paint0_linear_22_1799)",
    strokeWidth: 1.11111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.222222,
    d: "M1485.71 311.685C1382.31 351.857 1268.09 397.587 1041.48 438.308C814.872 479.029 736.635 496.107 608.223 555.428C479.811 614.748 438.312 622.501 136.585 632.993C-165.695 643.503 -560.807 823.347 -560.807 823.347",
    stroke: "url(#paint1_linear_22_1799)",
    strokeWidth: 1.22222
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333333,
    d: "M1493.98 279.864C1391.29 323.86 1277.92 373.984 1050.54 417.152C823.158 460.321 744.801 478.623 617.73 543.875C490.658 609.128 449.032 617.366 144.132 625.634C-161.326 633.916 -552.447 831.676 -552.447 831.676",
    stroke: "url(#paint2_linear_22_1799)",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444444,
    d: "M1501.34 247.938C1399.45 295.745 1287.05 350.247 1058.91 395.903C830.777 441.559 752.321 461.094 626.757 532.249C501.193 603.404 459.444 612.134 151.203 618.294C-157.602 624.464 -544.227 840.052 -544.227 840.052",
    stroke: "url(#paint3_linear_22_1799)",
    strokeWidth: 1.44444
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.555556,
    d: "M1507.77 215.928C1406.8 267.531 1295.48 326.391 1066.6 374.575C837.727 422.758 759.191 443.536 635.302 520.558C511.414 597.581 469.547 606.811 157.799 610.984C-154.52 615.164 -536.146 848.48 -536.146 848.48",
    stroke: "url(#paint4_linear_22_1799)",
    strokeWidth: 1.55556
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    d: "M1513.27 183.851C1413.31 239.232 1303.19 302.429 1073.6 353.181C844.006 403.932 765.41 425.96 643.363 508.813C521.315 591.666 479.335 601.401 163.919 603.714C-152.075 606.032 -528.201 856.963 -528.201 856.963",
    stroke: "url(#paint5_linear_22_1799)",
    strokeWidth: 1.66667
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.777778,
    d: "M1517.84 151.728C1418.99 210.866 1310.2 278.375 1079.91 331.734C849.614 385.093 770.976 408.38 650.936 497.022C530.896 585.663 488.808 595.911 169.563 596.496C-150.265 597.082 -520.393 865.505 -520.393 865.505",
    stroke: "url(#paint6_linear_22_1799)",
    strokeWidth: 1.77778
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.888889,
    d: "M1524.61 119.465C1426.98 182.338 1319.62 254.132 1088.65 310.139C857.681 366.145 779.023 390.7 661.155 485.084C543.287 579.468 501.095 590.236 177.868 589.229C-145.95 588.22 -509.585 873.998 -509.585 873.998",
    stroke: "url(#paint7_linear_22_1799)",
    strokeWidth: 1.88889
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1524.18 87.4143C1427.86 153.998 1322.05 230.046 1090.43 288.741C858.804 347.436 780.146 373.266 664.613 473.343C549.081 573.419 506.792 584.713 179.43 582.255C-148.53 579.794 -505.179 882.778 -505.179 882.778",
    stroke: "url(#paint8_linear_22_1799)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_1799",
    x1: -606.991,
    y1: 785.853,
    x2: 1470.5,
    y2: 316.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_1799",
    x1: -600.464,
    y1: 789.348,
    x2: 1478.5,
    y2: 281.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_1799",
    x1: -594.256,
    y1: 792.948,
    x2: 1485.46,
    y2: 247.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_1799",
    x1: -588.365,
    y1: 796.662,
    x2: 1491.36,
    y2: 212.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_1799",
    x1: -582.787,
    y1: 800.499,
    x2: 1496.22,
    y2: 177.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_1799",
    x1: -577.519,
    y1: 804.467,
    x2: 1500.02,
    y2: 142.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_1799",
    x1: -572.559,
    y1: 808.574,
    x2: 1502.78,
    y2: 107.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_1799",
    x1: -564.768,
    y1: 812.718,
    x2: 1507.61,
    y2: 71.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_1799",
    x1: -563.546,
    y1: 817.238,
    x2: 1505.13,
    y2: 36.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#2976E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#E9687B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavelines1);
export default __webpack_public_path__ + "static/media/wavelines1.6bce12ac03d8154cea665f52c7f78adf.svg";
export { ForwardRef as ReactComponent };